import { render, staticRenderFns } from "./TeamsTable.vue?vue&type=template&id=0c82e978&scoped=true&"
import script from "./TeamsTable.vue?vue&type=script&lang=js&"
export * from "./TeamsTable.vue?vue&type=script&lang=js&"
import style0 from "./TeamsTable.vue?vue&type=style&index=0&id=0c82e978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c82e978",
  null
  
)

export default component.exports
import {QCard,QTable,QInput,QIcon,QBtn,QMenu,QList,QSeparator,QItem,QItemSection,QCardSection,QAvatar,QPopupProxy,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QInput,QIcon,QBtn,QMenu,QList,QSeparator,QItem,QItemSection,QCardSection,QAvatar,QPopupProxy})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
